import { useState } from 'react';

import { useEffectOnce } from './utils';

export const useIsMobileDevice = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffectOnce(() => {
    const userAgent =
      typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
    const mobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent,
      );
    setIsMobile(mobile);
  });

  return isMobile;
};
